export * from './src/simple.widget';